import React, { useEffect, useRef, useState } from 'react'
import Reactportal from '../../../Reactportal/Reactportal'
import PortalFooter from '../../../Reactportal/PortalFooter';
import { ClearSpecificForm } from '../../../../../Store/FormDataReducer/FormFieldFunctions';
import { useModalContext } from '../../../Reactportal/ModalContext';
import { useDispatch } from 'react-redux';
import { InputsInTable } from '../../../InputInTable/InputsInTable';
import Button from '../../../Button/Button';
import { updateFieldByNameInRow, updateFieldInRow } from '../../AddCreditNote/CreditNoteFunctions';
import { GiConsoleController } from 'react-icons/gi';
import "./MultiPartNameSelectModal.scss";
import { useSelector } from 'react-redux';

const initialHeaders = ["Part Name", "Part Number", "Quantity"];
const fields = [
    {
        id: Math.random() * 10,
        name: "Part_Name",
        Input: true,
        type: "InputDropForQuery",
        masterName: "gtPartData",
        Reference_field: ["Consignor", "Customer_Account"],
        value: "",
        _id: "",
    },
    {
        id: Math.random() * 10,
        name: "Part_Number",
        Input: true,
        type: "Text",
        value: "",
        _id: "",
    },
    {
        id: Math.random() * 10,
        name: "Quantity_Per_Box",
        Input: true,
        type: "Number",
        value: "",
        _id: "",
    },

];


const MultiPartNameSelectModal = ({ show, setOpenPartNameModal, partNameData, setPartNameData }) => {
    const [toggle, setToggle] = useState(show ? show : false);
    const { pushModal, popModal } = useModalContext();
    const Form_Key = "MultiPartNameSelectModal";
    const dispatch = useDispatch();
    const FormDataFromRedux = useSelector((store: any) => store?.FormDataReducer);
    const [headers, setheaders] = useState([...initialHeaders]);
    const [PartNameTableData, setPartNameTableData] = useState({
        [Math.random() * 10]: fields,
        [Math.random() * 10]: fields,
        [Math.random() * 10]: fields,
        [Math.random() * 10]: fields,
        [Math.random() * 10]: fields,
    });
    const scrollContainerRef = useRef(null);

    // useEffect(() => {
    //     console.log("PartNameTableData", PartNameTableData);
    // }, [PartNameTableData]);


    useEffect(() => {
        if (partNameData?.length) {
            const transformedData = {};

            partNameData.forEach((item, idx) => {
                dispatch({
                    type: "StoreMasterData",
                    payload: {
                        formkey: Form_Key,
                        data: { [item?._id]: { Part_Name: item?.Part_Name } },
                    },
                });
                const rowKey = item?._id;
                transformedData[rowKey] = fields.map((field) => {
                    let value = item[field.name] ?? "";

                    if (field.name === "Part_Name" && item.Part_Name?.Part_Name) {
                        value = item.Part_Name?.Part_Name;
                    }

                    return {
                        ...field,
                        value,
                    };
                });
            });
            setPartNameTableData(transformedData)
        }
    }, [partNameData])

    const closeFormFunction = () => {
        popModal(Form_Key);
        setToggle(false);
        setOpenPartNameModal(false);
        // setIsPriceListClicked({ flag: false, data: {} });
        ClearSpecificForm(dispatch, Form_Key);
    };

    const handlePartNameInputChange = async (evt, id, rowId, i, name) => {
        let tableobjdata = PartNameTableData
        let updatedData = updateFieldInRow(tableobjdata[rowId], id, evt.target.value);

        tableobjdata = {
            ...tableobjdata,
            [rowId]: updatedData,
        }
        let FillPartNumber;
        if (name == "Part_Name") {
            let PartNo = FormDataFromRedux?.MasterData?.[Form_Key]?.[rowId]?.Part_Name?.Part_Number
            // let QuantPerBox = FormDataFromRedux?.MasterData?.[Form_Key]?.[rowId]?.Part_Name?.Quantity_Per_Box
            FillPartNumber = updateFieldByNameInRow(tableobjdata[rowId], "Part_Number", PartNo);
            // tableobjdata = {
            //     ...tableobjdata,
            //     [rowId]: FillPartNumber,
            // }
            // FillPartQuantity = updateFieldByNameInRow(tableobjdata[rowId], "Quantity_Per_Box", Number(QuantPerBox));
            // console.log(FillPartNumber, "updatedDataupdatedDataupdatedData")
        }


        setPartNameTableData((prevData) => ({
            ...prevData,
            [rowId]: name == "Part_Name" ? FillPartNumber : updatedData,
        }));
    };

    const addNewRowOfPriceListRate = () => {
        const newRowKey = `row_${Object.keys(PartNameTableData).length}`;
        const newRow = fields.map((field) => ({
            ...field,
            value: "",
        }));

        setPartNameTableData((prevData) => {
            const updatedData = {
                ...prevData,
                [newRowKey]: newRow,
            };

            setTimeout(() => {
                if (scrollContainerRef.current) {
                    scrollContainerRef.current.scrollTo({
                        top: scrollContainerRef.current.scrollHeight,
                        behavior: "smooth",
                    });
                }
            }, 0);

            return updatedData;
        });
    };

    const HandleDeletePartName = (rowId) => {
        delete PartNameTableData[rowId];
        setPartNameTableData(PartNameTableData);
    };

    let submit = () => {
        const userInputOfPriceList = [];
        Object.entries(PartNameTableData).forEach(([key, row]) => {
            // console.log(key, row, "key & row");

            const formattedRow: any = {};
            const allEmpty = row.every((field) => field.value === "");

            if (!allEmpty) {
                row.forEach((field) => {
                    formattedRow[field.name] = field.value;
                });
                formattedRow._id = key;
                formattedRow.Part_Name = FormDataFromRedux?.MasterData?.[Form_Key]?.[key]?.Part_Name;
                formattedRow.Quantity_Per_Box = formattedRow.Quantity_Per_Box ? Number(formattedRow.Quantity_Per_Box) : 0;
                userInputOfPriceList.push(formattedRow);
            }
        });
        setPartNameData(userInputOfPriceList)
        closeFormFunction()
        // console.log(userInputOfPriceList, "userInputOfPriceList");
    }

    const footerContent = (
        <PortalFooter
            renderContent={() => <></>}
            disabled={false}
            // submitType="Save"
            // submitform={submit}
            SaveAndClose={submit}
            Form_key={Form_Key}
            handleformclose={() => {
                closeFormFunction();
                setToggle(!toggle);
            }}
            loadingState={false}
        />
    );
    return (
        <div>
            <Reactportal
                TypeOfPortal={"Select Part Name"}
                FoooterContent={footerContent}
                open={toggle}
                onClose={closeFormFunction}
                Form_Key={Form_Key}
            >  <div className="Part_Name_Table">
                    {/* <div className="Page_Title_Container_For_Price_List">{"Price List Rates"}</div> */}
                    <div className="Price_List_Rates_Table_Container" ref={scrollContainerRef}>
                        <InputsInTable
                            title={"CreditNoteData"}
                            headers={headers}
                            data={PartNameTableData}
                            HandleInputChange={handlePartNameInputChange}
                            handleOnFocus={() => { }}
                            handleDelete={HandleDeletePartName}
                            formkey={Form_Key}
                        />
                    </div>
                    <Button text="Add" name="modalbutton" action={() => addNewRowOfPriceListRate()} />
                </div></Reactportal>
        </div>
    )
}

export default MultiPartNameSelectModal